import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import ExtraInfo from "../dashboard/components/ExtraInfo";
import { CgProfile } from "react-icons/cg";
import { MdRedeem, MdOutlineSpaceDashboard } from "react-icons/md";
import { VscFeedback } from "react-icons/vsc";
import { RiMoneyDollarCircleLine, RiUserSharedLine, RiSurveyLine} from "react-icons/ri";
import { MdCardGiftcard } from "react-icons/md";
import { RiShareForward2Line } from "react-icons/ri";
import { GrMoney } from "react-icons/gr";
import ProfileCompletionModal from "../dashboard/components/ProfileCompletionModal";
const DashboardLayout = () => {
  return (
    <div>
      
      <div className="dashboard-header linkedin-style-header">
        <div className="linkedin-header-content">
          <div className="header-left">
            {/* <div className="close-arrow" onClick={handleToggleSidebar}>
              <FaBars />
            </div> */}
            <div className="brand">
             <img src="/logo/Poll_Sphere_Logo-04.png" alt="" />
            </div>
          </div>

          <div className="header-center">
            <NavLink to="/dashboard" className="nav-item">
              <MdOutlineSpaceDashboard className="nav-icon" />
              <span className="nav-label">Dashboard</span>
            </NavLink>
            <NavLink to="/survey" className="nav-item">
              <RiSurveyLine className="nav-icon" />
              <span className="nav-label">Paid Survey</span>
            </NavLink>
            <NavLink to="/feedback" className="nav-item">
              <VscFeedback className="nav-icon" />
              <span className="nav-label">Feedback</span>
            </NavLink>
            <NavLink to="/refer" className="nav-item">
              <RiShareForward2Line className="nav-icon" />
              <span className="nav-label">Refer & Earn</span>
            </NavLink>
            <NavLink to="/passbook" className="nav-item">
              <GrMoney className="nav-icon" />
              <span className="nav-label">Passbook</span>
            </NavLink>
           
           <NavLink to="/reward" className="nav-item">
              <MdCardGiftcard className="nav-icon" />
              <span className="nav-label">Redeem</span>
            </NavLink>
          </div>

        </div>
      </div>
      <div className="main-content-wrapper">
          <div className="page-content container ">
            <Outlet />
          </div>
          <div className="bottom-nav">
            <NavLink
              to="/profile-survey"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <div className="icon">
                <CgProfile size={24} />
              </div>
              <span>Profile</span>
            </NavLink>

            <NavLink
              to="/survey"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <div className="icon">
                <RiSurveyLine size={24} />
              </div>
              <span>Survey</span>
            </NavLink>

            <NavLink
              to="/refer"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <div className="icon">
                <RiUserSharedLine size={24} />
              </div>
              <span>Refer</span>
            </NavLink>

            <NavLink
              to="/earning"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <div className="icon">
                <RiMoneyDollarCircleLine size={24} />
              </div>
              <span>Earning</span>
            </NavLink>

            <NavLink
              to="/reward"
              className={({ isActive }) =>
                `nav-item ${isActive ? "active" : ""}`
              }
            >
              <div className="icon">
                <MdRedeem size={24} />
              </div>
              <span>Redeem</span>
            </NavLink>
          </div>
          <div className="dashboard-footer py-3 mt-4">
            <p className="text-center mb-0">©  Poll Sphere Tool  </p>
          </div>
        </div>
     
      {/* <ExtraInfo /> */}
      <ProfileCompletionModal />
    </div>
  );
};

export default DashboardLayout;
